function directive(getSize, getData, generateId, $interval, $window) {
    return {
        link: function ($scope, element, attrs, piCtrl) {
            var size = getSize(element, 'pieChart');
            var width = size.width;
            var height = size.height;
            let piechart;
            $scope.page.w = angular.element($window);
                let obj = {}, array = [];
            // element[0].insertAdjacentHTML('beforebegin', spinnerHTML); // start spinner
            // element[0].parentNode.querySelector('.loader').setAttribute('style', 'height:'+(height/2)+'px; position:relative; margin:'+(height/2)+"px 0px -"+(height)+"px 0px;zoom:0.5; -moz-transform: scale(0.5);");

            var dimension, group, chartType, settings, cid, chartUid, filter, div = "#piechart", searchCategories, filter_column, filter_title; // set our default vairables
            $scope.$on('init', function (event, chart) {
                if (chart.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') { return } // if its not in our dc object, ignore
                $scope.main.dataObjects[chart.key].launched = true;

                var uid = chart.id;
                var key = chart.key;

                dimension = $scope.main.dataObjects[key].dimension;
                group = $scope.main.dataObjects[key].group;
                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
                if (typeof $scope.main.dataObjects[key].div !== 'undefined') {
                    div = "#"+$scope.main.dataObjects[key].div;
                }

                filter_column = $scope.main.dataObjects[key].settings.filter_column;
                filter_title = searchCategories[filter_column];

                cid = uid;
                chartUid = generateId();
                filter = true;

                var colors;
                if (typeof $scope.page.color !== "undefined") {
                    colors = $scope.page.color;
                } else {
                    colors = d3.scale.category20();
                }

                var dataset = [];

                var radius = Math.min(width, height) / 2;
                let topGroup = [];

                var enterAntiClockwise = {
                    startAngle: Math.PI * 2,
                    endAngle: Math.PI * 2
                };

                var pie = d3.layout.pie()
                    .value(function (d) { return d.value; })
                    .sort(null);

                var arc = d3.svg.arc()
                    .innerRadius(radius - (radius*0.6))
                    .outerRadius(radius - (radius*0.15));

                var outterDiv = d3.select(div).append("svg")
                    .attr("width", width)
                    .attr("height", height)
                var svg = outterDiv.append("g")
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
                var legend = outterDiv.append("g")
                    .attr("class", "legend")
                    .attr("transform", "translate(0,0)");

                // draws the pie chart TODO: translation
                function redraw () {
                    topGroup = getTop();
                    svg.selectAll("g.arc").remove();
                    // set up groups
                    var arcsCont = svg.selectAll("g.arc").data(pie(topGroup))
                    var arcs = arcsCont.enter()
                        .append("g")
                        .attr("class", "arc")
                        .attr("transform", "translate(" + 0 + "," + 0 + ")")
                        .on("click", function (d) {
                            handleFilter(d)
                        });
                    // draw arc paths
                    let path = arcs.append("path")
                        .attr("fill", function (d, i) {
                            return colors(d.data.key);
                        })
                        .attr("d", arc)
                        .each(function (d) {
                            this._current = d;
                        });
                    doLegend();
                }
                // gets the top 9 grouping of the piechart data
                function getTopData () {
                    dataset = [];
                    for (var g in group.top(9)) {
                        dataset.push(group.top(9)[g].value)
                    }
                }
                // get the top groups then set the rest to "Other"
                function getTop () {
                    array = []
                    if (obj.hasOwnProperty('Other')) {
                        obj["Other"] = {key : "Other", value :0 };
                    }
                    group.top(Infinity).map(function (d) {
                        if (obj.hasOwnProperty(d.key)) {
                            obj[d.key] = d;
                        } else if (Object.keys(obj).length < 9) {
                            obj[d.key] = d;
                        } else {
                            if (!obj.hasOwnProperty('Other')) {
                                obj["Other"] = {key : "Other", value :0 };
                            }
                            obj["Other"].value += d.value;
                        }
                    })
                    for (var o in obj) {
                        array.push(obj[o])
                    }
                    return array;
                }
                // handles the filtering, only difference is when its 'other' it excludes the other top groupings
                function handleFilter (node) {
                    let action = 'include';
                    let filters = [];
                    if (node.data.key === "Other") {
                        action = 'exclude';
                        for (var t in topGroup) {
                            if (topGroup[t].key !== "Other") {
                                filters.push(topGroup[t].key)
                            }
                        }
                    } else {
                        filters.push(node.data.key)
                    }
                    for (var i = 0, len = filters.length; i < len; i++) {
                        $scope.main.filterItem(filter_column, filters[i], action, filter_title, false);
                    }
                }

                //////////////
                /// LEGEND ///
                //////////////
                var legendLines;
                function doLegend() {
                    legend.selectAll(".legendLines").remove();
                    legendLines = legend.selectAll(".legendLines")
                        .data(pie(topGroup))
                        .enter().append("g")
                        // .attr("class", "legendLines")
                        .attr("class", function (d,i) {
                            if (d.value > 0) {
                                return "legendLines"
                            }
                            return "legendLines grey"
                        })
                        .attr("transform", function (d, i) { return "translate(11," + ((i)*15) + ")"; })
                        .on("click",function(d) {
                            if (d.value > 0) {
                                handleFilter(d)
                            }
                        })
                    legendLines.append("rect")
                        .attr("x", 0)
                        .attr("height", 10)
                        .attr("width", 10)
                        .style("fill", function (d,i) {
                            if (d.value > 0) {
                                return colors(d.data.key)
                            }
                            return "#ddd"
                        });
                    legendLines.append("text")
                        .attr("x",14)
                        .attr("y", 5)
                        .attr("dy", ".35em")
                        .text(function (d) {
                            return d.data.key.replace("N/A", "-");
                        });
                }

                // once piechart is finished getting its data, it then creates an object with the proper most popular groupings
                $scope.page.setGroupObj = function (object) {
                    obj = angular.copy(object);
                    getTopData();
                    redraw();
                }
                // set update functions
                $scope.$on('updatedData', function (event, id, initial) {
                    if (id !== uid) { return } // only run when it sees its id has filtered
                    getTopData();
                    redraw();
                });
            });
            $scope.$on('$destroy', function () {
                element.remove();
                piechart = undefined;
                $scope.page.w = null;
            });
        }
    };
}

directive.$inject = ['getSize', 'getData', 'generateId', '$interval', '$window'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/piechart/makepiechart.js
 **/